import PropTypes from "prop-types";
import SelfServiceDesktop from "./SelfServiceDesktop";

function SelfService({ app, currentSelectionsObject, config }) {
  return <SelfServiceDesktop app={app} config={config} />;
}

SelfService.defaultProps = {
  app: null,
  currentSelectionsObject: {
    qBackCount: 0,
    qForwardCount: 0,
    qSelections: [],
  },
  config: {},
};

SelfService.propTypes = {
  app: PropTypes.object,
  currentSelectionsObject: PropTypes.object,
  config: PropTypes.object,
};

export default SelfService;
